export default __webpack_public_path__ + "static/media/good_job.96578b51.svg";